import { render, staticRenderFns } from "./Extraviada.vue?vue&type=template&id=54e2cdac&"
import script from "./Extraviada.vue?vue&type=script&lang=js&"
export * from "./Extraviada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports